// The visual ranking: posters with gold rank badges (ranked) or a balanced,
// number-free arrangement (unranked). Used by the public page, the creator's
// preview and the profile sections. Missing artwork falls back to a titled card.
// Items may carry `kind` ('movie' default, or 'tv' — Custom Rankings): series
// link to their TV page and are captioned "TV".
import { Link } from 'react-router-dom';
import styles from './TopMovies.module.css';

export function PosterImage({ movie, className = '' }) {
    return movie.posterUrl
        ? <img className={className} src={movie.posterUrl} alt={`${movie.title} poster`} loading="lazy" />
        : <div className={`${styles.posterFallback} ${className}`} aria-label={`${movie.title} (no poster)`}><span>{movie.title}</span></div>;
}

/**
 * `ranked` draws the rank badges. `label` overrides the list's accessible name
 * (Custom Rankings keep "in order" even with the numbers hidden: it is still
 * an ordered list).
 */
export default function TopMoviesGrid({ movies, ranked = true, size, compact = false, linkMovies = true, label }) {
    const columns = (size || movies.length) > 5 ? styles.gridTen : styles.gridFive;
    return (
        <ol className={`${styles.grid} ${columns} ${compact ? styles.gridCompact : ''} ${ranked ? '' : styles.unranked}`} aria-label={label || (ranked ? 'Ranked movies' : 'Movies')}>
            {movies.map((movie, index) => {
                const poster = (
                    <span className={styles.posterFrame}>
                        <PosterImage movie={movie} />
                        {ranked && <span className={styles.rankBadge} aria-label={`Number ${index + 1}`}>{index + 1}</span>}
                    </span>
                );
                return (
                    <li key={`${movie.kind || 'movie'}:${movie.tmdbId}`} className={styles.gridItem}>
                        {linkMovies ? <Link to={`/movie/${movie.kind === 'tv' ? 'tv' : 'movie'}/${movie.tmdbId}`} className={styles.posterLink}>{poster}</Link> : poster}
                        {!compact && (
                            <span className={styles.caption}>
                                <strong>{movie.title}</strong>
                                {movie.year && <span>{movie.year}</span>}
                                {movie.kind === 'tv' && <span className={styles.kindTag}>TV</span>}
                            </span>
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
